import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, Select, message } from "antd";
import API from "../../api";

const { Option } = Select;

const StoreForm = ({ open, setOpen, initialValue, isEdit, onSubmit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [managers, setManagers] = useState([]);
  const [specifications, setSpecifications] = useState(
    initialValue?.specifications || []
  );

  // Fetch managers when component mounts or the form opens
  const getManagers = async () => {
    try {
      const response = await API.get("/users/role/manager");
      setManagers(response.data);
    } catch (err) {
      console.error("Error fetching managers:", err);
    }
  };

  // Populate the form when store changes
  useEffect(() => {
    getManagers();
    if (open) {
      if (isEdit && initialValue) {
        form.setFieldsValue({
          ...initialValue,
          store: initialValue.store?._id || undefined, 
        });
        setSpecifications(initialValue.specifications || []); 
      } else {
        form.resetFields(); 
        setSpecifications([]); 
      }
    }
  }, [isEdit, initialValue, open]); 

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = { ...values, specifications };
      await onSubmit(payload);
      form.resetFields();
      setSpecifications([]);
      setOpen(false);
    } catch (error) {
      console.error("Submit failed:", error);
      message.error(error.response?.data?.message || "Error saving store.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={isEdit ? "Edit Store" : "Add Store"}
      width={500}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Branch Name"
          name="name"
          rules={[{ required: true, message: "Please enter the branch name!" }]}
        >
          <Input placeholder="Enter Branch Name"/>
        </Form.Item>
        <Form.Item
          label="Billing Header Name"
          name="billingHeaderName"
        >
          <Input placeholder="Enter Billing Header Name"/>
        </Form.Item>

        <Form.Item
          label="Address"
          name="address"
          rules={[{ required: true, message: "Please enter the address!" }]}
        >
          <Input placeholder="Please enter the address"/>
        </Form.Item>
        <Form.Item
          label="State"
          name="state"
          rules={[{ required: true, message: "Please enter the State!" }]}
        >
          <Input placeholder="Please enter the State"/>
        </Form.Item>
        <Form.Item
          label="StateCode"
          name="stateCode"
        >
          <Input placeholder="Please enter the StateCode"/>
        </Form.Item>
        <Form.Item
          label="PAN"
          name="pan"
        >
          <Input placeholder="Please enter the PAN"/>
        </Form.Item>
        <Form.Item
          label="GST No"
          name="gstNo"
        >
          <Input placeholder="Please enter the GST No"/>
        </Form.Item>

        <Form.Item
          label="Phone"
          name="phone"
          rules={[{ required: true, message: "Please enter the phone number!" }]}
        >
          <Input placeholder="Please enter the phone number"/>
        </Form.Item>

        <Form.Item
          label="Manager"
          name="managerId"
          rules={[{ required: true, message: "Please select a manager!" }]}
        >
          <Select placeholder="Select Manager">
            {managers.map((manager) => (
              <Option key={manager?._id} value={manager?._id}>
                {manager?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default StoreForm;
